import { ParamMap } from '@angular/router';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { parsePagingQuery } from 'src/app/shared/helpers/grid-query-params';

export const CONTACTS_ORDER_BY = ['lastName', 'CompanyName'];

/**
 * Builds the contact list search request from the URL query params.
 * Used by both the resolver and the list component so that every page is
 * loaded with the same paging, ordering and filter.
 */
export function buildContactsSearchRequest(q: ParamMap): IBaseSearchRequest {
  const paging = parsePagingQuery(q);
  const request: IBaseSearchRequest = {
    pageNumber: paging.pageNumber,
    pageSize: paging.pageSize,
    orderBy: [...CONTACTS_ORDER_BY],
  };

  const keyword = q.get('keyword');
  if (keyword) request.keyword = keyword;

  return request;
}
